import type { Team } from "@redotech/redo-model/team";
import type { GetUser } from "@redotech/redo-model/user";

/**
 * Returns the most specific email signature for the given sender context.
 * Precedence: per-sender → personal (when usePersonalSignature) → team.
 */
export function pickSignature({
  senderEmailAddress,
  team,
  user,
}: {
  senderEmailAddress?: string | null;
  team?: Team | null;
  user?: GetUser | null;
}): string | null {
  if (senderEmailAddress) {
    const senderEmail = team?.settings?.support?.senderEmails?.find(
      (s) => s.email === senderEmailAddress,
    );
    if (senderEmail?.emailSignature) {
      return senderEmail.emailSignature;
    }
  }

  if (user?.usePersonalSignature && user.emailSignature) {
    return user.emailSignature;
  }

  return team?.settings?.support?.emailSignature ?? null;
}
